export const skinTones = [
  { id: 1, name: "Claro", color: "#FFD1B3" },
  { id: 2, name: "Medio", color: "#E8B896" },
  { id: 3, name: "Moreno", color: "#C68642" },
  { id: 4, name: "Oscuro", color: "#8D5524" }
];

export const hairStyles = [
  { id: 1, name: "Corto", type: "short" },
  { id: 2, name: "Largo", type: "long" },
  { id: 3, name: "Rizado", type: "curly" },
  { id: 4, name: "Calvo", type: "bald" }
];

export const accessories = [
  { id: 1, name: "Lentes", type: "glasses" },
  { id: 2, name: "Bigote", type: "mustache" },
  { id: 3, name: "Gorro", type: "hat" },
  { id: 4, name: "Sin accesorio", type: "none" }
];

export const outfits = [
  { id: 1, name: "Casual", type: "casual" },
  { id: 2, name: "Formal", type: "formal" },
  { id: 3, name: "Deportivo", type: "sport" },
  { id: 4, name: "Elegante", type: "elegant" }
];